import { render, staticRenderFns } from "./MaydayEditorOpenLinkModal.vue?vue&type=template&id=5890e0a1&"
import script from "./MaydayEditorOpenLinkModal.vue?vue&type=script&lang=js&"
export * from "./MaydayEditorOpenLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports